<template>
    <div class="svg-container limit-width">
        <svg id="ie-pie-chart"></svg>
    </div>
</template>

<script>
    // import { gsap } from '/src/assets/js/gsap';
    import * as d3 from "d3";
    
    export default {
        name: 'pie',
        props : { chartData:Object },
        data () {
            return {}
        },
        mounted () {
            this.dataCheck(this.chartData);
        },
        methods: {
            dataCheck (obj) {
                if(this.isObject(obj)) {
                    this.makePie();
                }
            },
            isObject (obj) {
                return obj != null && obj.constructor.name === "Object"
            },
            makePie () {
                const height = 800;
                const width = 900;
                const chartWidth = 600;
                const chartHeight = 600;
                const margin = 100;
                const radius = Math.min(width, height) / 2 - (margin/2);

                // append the svg object to the div called 'my_dataviz'
                const svg = d3.select("#ie-pie-chart")
                    .attr("width", chartWidth)
                    .attr("height", chartHeight)
                    .attr("viewBox", `0 0 ${width} ${height}`)
                    .attr("preserveAspectRatio", "xMidYMid meet")
                    .append("g")
                        .attr("transform", `translate(${width/2}, ${350})`); // places pie in the center

                // Create dummy data
                const chartData = this.chartData
                
                // set the color scale
                const color = d3.scaleOrdinal()
                    .range(["#4671c9", "#92d050", "#ce7958", "#58b9ce" ])

                // Compute the position of each group on the pie:
                const pie = d3.pie()
                    .value(function(d) {return d[1]})
                const pieData = pie(Object.entries(chartData))

                // Build pie chart
                svg
                    .selectAll('ie')
                    .data(pieData)
                    .join('path')
                    .attr('d', d3.arc()
                        .innerRadius(0)
                        .outerRadius(radius)
                    )
                        .attr('fill', function(d, i){ return(color(d.data[i])) })
                        .attr("stroke", "black")
                        .style("stroke-width", "5px")
                        .style("opacity", 1)
                
                const legendOffsetHeight = 50;
                const h = 40;
                
                svg
                    .append("g") 
                    .attr("class", "legend-block")

                const legend = svg.select(".legend-block")
                pieData.forEach((element, idx) => {
                    legend.append("text").attr("x", 50).attr("y", idx * legendOffsetHeight + 24).text(element.data[0]).style("font-size", "30px").attr("alignment-baseline","middle").attr("class", "legend cap")
                    legend.append("rect").attr("x", 0).attr("y", idx * legendOffsetHeight).attr("width", h).attr("height", h).style("fill", color(element.data[idx]))
                })
                
                const newHeight = (height/2) - ((pieData.length - 1) * h);
                
                svg
                    .select(".legend-block")
                    .attr("transform", "translate(" + (-width/2 + legendOffsetHeight) + "," + newHeight + ")")

                // Title
                // svg
                //     .append("g") 
                //     .attr("class", "title")
                
                // svg
                //     .select(".title")
                //     .append("text")
                //     .attr("x", 0)
                //     .attr("y", -newHeight - 30)
                //     .text('Your Choices Categorized')
                //     .style("font-size", "48px")
                //     .style("text-anchor", "middle")
                //     .attr("class", "chart-title")
                
            },
            wrap (text, width) {
                text.each(function() {
                    var text = d3.select(this),
                        words = text.text().split(/\s+/).reverse(),
                        word,
                        line = [],
                        lineNumber = 0,
                        lineHeight = 1.1, // ems
                        y = text.attr("y"),
                        dy = parseFloat(text.attr("dy")),
                        tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
                    while (word = words.pop()) {
                    line.push(word);
                    tspan.text(line.join(" "));
                    if (tspan.node().getComputedTextLength() > width) {
                        line.pop();
                        tspan.text(line.join(" "));
                        line = [word];
                        tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
                    }
                    }
                });
            }
        }  
    }
</script>
